export enum MandatorParameterKeys {
  CSH_REBATE_ASK_FOR_EMPLOYEE = 'CSH_REBATE_ASK_FOR_EMPLOYEE',
  CSH_DISCOUNT_RANGE_1 = 'CSH_DISCOUNT_RANGE_1',
  CSH_DISCOUNT_RANGE_2 = 'CSH_DISCOUNT_RANGE_2'
}
